import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, InputGroup } from 'react-bootstrap';
import y, { isEmptyPropertyThenTo } from 'y4/Utils';
import classNames from 'classnames';
import FormItem from './FormItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FormInputGroup = ({ panel, field, data, onChange, eventTarget }) => {
  const md = isEmptyPropertyThenTo(field, 'other.breakpoint.md', 12);
  const xl = isEmptyPropertyThenTo(field, 'other.breakpoint.xl', 4);
  const xxl = isEmptyPropertyThenTo(field, 'other.breakpoint.xxl', 3);
  const vf = y.gpv(field, 'other.visible');
  const visible_init = vf ? eval(vf.formula) : true;
  const [visible, setVisible] = useState(visible_init);
  useEffect(() => {
    //Add evet at item chaged
    if (vf) {
      eventTarget.addEventListener('itemChanged', e => {
        if (y.include(vf.dependence, y.getFieldName(e.detail.field))) {
          const v = eval(vf.formula);
          setVisible(v);
        }
      });
    }
  }, [eventTarget]);

  if (visible) {
    const top_title = field.extraType == 'Image';
    return (
      <Col md={md} xl={xl} xxl={xxl}>
        <InputGroup className="mb-3">
          {field.title && (
            <span
              id={field.name + 'Label'}
              className={classNames({
                'w-100': top_title,
                'rounded-top': top_title,
                'input-group-text': !top_title,
                'input-group-text-top': top_title
              })}
            >
              {field.required && <span className="text-danger">*</span>}
              {field.title}
              {field.columnTip && (
                <FontAwesomeIcon
                  icon={['fas', 'question-circle']}
                  className="text-info fs--1 ms-1"
                  onClick={() => {
                    y.modal.alter(field.title, null, field.columnTip);
                  }}
                />
              )}
            </span>
          )}
          <FormItem
            dataCode={panel.dataCode}
            field={field}
            row={data.row}
            onChange={onChange}
            eventTarget={eventTarget}
          />
        </InputGroup>
      </Col>
    );
  } else {
    return null;
  }
};

FormInputGroup.propTypes = {
  panel: PropTypes.object,
  field: PropTypes.object,
  data: PropTypes.object,
  onChange: PropTypes.func,
  eventTarget: PropTypes.object
};

export default FormInputGroup;
